module.exports = __webpack_public_path__ + "static/pinkdressing-3d60f9c7a362a5bee26c86cb4e277682.png";